import script from "./SolicitudAcceso.vue?vue&type=script&setup=true&lang=js"
export * from "./SolicitudAcceso.vue?vue&type=script&setup=true&lang=js"

import "./SolicitudAcceso.vue?vue&type=style&index=0&id=4e95d758&scoped=true&lang=css"
import "./SolicitudAcceso.vue?vue&type=style&index=1&id=4e95d758&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e95d758"]])

export default __exports__